module.exports = __webpack_public_path__ + "assets/img/chartCard-ip.ebd7a271.svg";